export const CLOCK_START_TIME_BUFFER = 10 * 60 * 60
export const CLOCK_END_TIME_BUFFER = 10 * 60 * 60